import PropTypes from 'prop-types';
// @mui
import { Chip, Avatar, Checkbox, Stack, FormControlLabel } from '@mui/material';
// --------------------------------------------------------------------------------------------------------------

SubCategoryTags.propTypes = {
    post: PropTypes.object,
};
// --------------------------------------------------------------------------------------------------------------

export default function SubCategoryTags({ post }) {

    const { favorite, subCategoryTags, favoritePerson } = post;

    return (
        <>
            {subCategoryTags?.includes(',') ?
                (
                    <Stack direction="row" flexWrap="wrap" sx={{ height: '3em' }}>
                        {subCategoryTags?.split(',').map((tag) => (
                            <Chip key={tag} label={tag} sx={{ m: 0.2, height: "20px", fontSize: "8px", borderRadius: 0 }} />
                        ))}
                    </Stack>
                ) :
                <Stack direction="row" flexWrap="wrap">
                    {subCategoryTags &&
                        <Chip key={subCategoryTags} label={subCategoryTags} sx={{ m: 0.2, height: "20px", fontSize: "8px", borderRadius: 0 }} />
                    }
                </Stack>
            }
        </>
    );
}
